import { render } from "./designify_cta.vue?vue&type=template&id=f85099ca&scoped=true"
import script from "./designify_cta.vue?vue&type=script&lang=js"
export * from "./designify_cta.vue?vue&type=script&lang=js"

import "./designify_cta.vue?vue&type=style&index=0&id=f85099ca&lang=scss&scoped=true"
import "./designify_cta.vue?vue&type=style&index=1&id=f85099ca&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f85099ca"]])

export default __exports__